// Hazard-family helpers shared across the Observatory UI.

export const HAZARDS = ["seismic", "fire", "storm", "volcano", "tsunami", "flood", "landslide"];

export function getHazard(obs) {
  if (obs?.hazard) return obs.hazard;
  const k = obs?.kind || "";
  if (k.startsWith("seismic")) return "seismic";
  if (k.startsWith("fire")) return "fire";
  if (k.startsWith("storm")) return "storm";
  if (k.startsWith("so2")) return "volcano";
  if (k.startsWith("river") || k.startsWith("flood")) return "flood";
  if (k.startsWith("landslide") || k.startsWith("glof")) return "landslide";
  if (k.startsWith("tsunami") || k.startsWith("dart")) return "tsunami";
  return "seismic";
}

// Base (nominal) colour per hazard. Anomalies always override to red/orange.
export const HAZARD_BASE = {
  seismic: "#B388FF",
  fire: "#34D399",
  storm: "#60A5FA",
  volcano: "#F472B6",
  tsunami: "#2DD4BF",
  flood: "#0EA5E9",
  landslide: "#C2703D",
};

export const HAZARD_TAG = {
  seismic: "SEISMIC",
  fire: "FIRE",
  storm: "STORM",
  volcano: "VOLCANO",
  tsunami: "TSUNAMI",
  flood: "FLOOD",
  landslide: "LANDSLIDE",
};

export function hazardTag(obs) {
  const k = obs?.kind || "";
  if (k === "glof_watch") return "GLOF";
  if (k === "landslide_dam") return "RIVER DAM";
  if (k === "fire_complex") return "FIRE COMPLEX";
  if (k === "quake_swarm") return "SWARM";
  return HAZARD_TAG[getHazard(obs)] || "OBS";
}

export const HAZARD_TITLE = {
  all: "Multi-Hazard · Planetary Early-Warning",
  seismic: "Seismicity Rate · Swarm / Rate Anomaly",
  fire: "Fire-Weather Risk · FFWI Anomaly",
  storm: "Storm Precursors · Pressure / Gust / CAPE",
  volcano: "Volcanic Unrest · SO₂ Degassing",
  tsunami: "Tsunami Watch · DART & Shallow Quakes",
  flood: "River Flood Risk · GloFAS Discharge",
  landslide: "Landslide & GLOF · Slope-Failure Nowcast",
};

export const HAZARD_LABEL = {
  seismic: "Seismic",
  fire: "Fire Risk",
  storm: "Storms",
  volcano: "Volcano",
  tsunami: "Tsunami",
  flood: "Flood",
  landslide: "Landslide",
};

// Normalised 0..1 intensity used for marker size / heat glow weight.
export function intensity(obs) {
  const h = getHazard(obs);
  const k = obs?.kind || "";
  const v = Math.max(0, obs?.value || 0);
  if (h === "seismic") return Math.min(1, v / 30);
  if (h === "fire") return Math.min(1, v / 80);
  if (h === "storm") return Math.min(1, v / 100);
  if (h === "volcano") return Math.min(1, v / 60);
  if (h === "flood") return Math.min(1, Math.abs(obs?.deviation_sigma || 0) / 6);
  if (h === "landslide") return Math.min(1, v / 100);
  return k.startsWith("dart") ? 0.2 : Math.min(1, v / 9);
}
